// extracted by mini-css-extract-plugin
export var navbarFrame = "WebFrame-module--navbarFrame--76b44";
export var noFrame = "WebFrame-module--noFrame--be2a5";
export var phoneFrame = "WebFrame-module--phoneFrame--959e0";